import { render, staticRenderFns } from "./regCenterProfile.vue?vue&type=template&id=6f2536c8&"
import script from "./regCenterProfile.vue?vue&type=script&lang=js&"
export * from "./regCenterProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports